import { computed, ref } from 'vue'

export function useAnimationFrameTask(fn: () => Promise<void>) {
  const animationFrameId = ref<number | null>(null)
  const running = ref(false)
  let taskInFlight = false

  function pause() {
    running.value = false

    if (animationFrameId.value !== null) {
      cancelAnimationFrame(animationFrameId.value)
      animationFrameId.value = null
    }
  }

  async function run() {
    animationFrameId.value = null
    if (!running.value || taskInFlight) {
      return
    }

    taskInFlight = true
    try {
      await fn()
    }
    catch (error) {
      running.value = false
      console.error(error)
    }
    finally {
      taskInFlight = false
    }

    if (running.value) {
      animationFrameId.value = requestAnimationFrame(run)
    }
  }

  function resume() {
    if (running.value) {
      return
    }

    running.value = true
    if (!taskInFlight) {
      run()
    }
  }

  const isRunning = computed(() => running.value)

  return {
    pause,
    resume,
    isRunning,
  }
}
